import styled from "styled-components";
export const Styles = styled.div`
  .logo-container {
    width: 100px;
    height: 100px;
    border-radius: 7px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: radial-gradient(circle, #51aafd, #002d68);
    .final-logo-container {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      padding: 40px;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      .final-logo {
        font-weight: 700;
        line-height: 50px;
      }
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`;
